import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { CATEGORIES, PHONE_TEL, waLink } from "../../data/site";
import Reveal, { ChapterTag } from "./Reveal";

export default function Categories() {
  return (
    <section id="categories" data-testid="categories-section" className="scroll-mt-24 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <ChapterTag index="01" label="Services" />
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
            All Scrap. One Trusted Buyer in Bangalore.
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-steel">
            From a single AC unit to full factory clearance — we handle pickup, dismantling,
            weighing and instant payment.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((cat, i) => (
            <motion.article
              key={cat.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.12 }}
              data-testid={`category-card-${cat.id}`}
              className="group flex flex-col overflow-hidden rounded-3xl border border-line/80 bg-white shadow-sm transition-[box-shadow,transform] duration-300 sm:hover:-translate-y-1.5 sm:hover:shadow-xl"
            >
              <div className="overflow-hidden">
                <img
                  src={cat.img}
                  alt={`${cat.name} in Bangalore`}
                  loading="lazy"
                  className={`h-56 w-full object-cover ${cat.position} transition-transform duration-500 sm:group-hover:scale-105`}
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-display text-xl font-bold tracking-tight text-ink">
                  {cat.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-steel">{cat.desc}</p>
                <div className="mt-6 space-y-3">
                  <a
                    href={waLink(`Hi, I'm interested in ${cat.name}. Please provide a quote for my location.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`category-whatsapp-${cat.id}`}
                    className="flex items-center justify-center gap-2 rounded-full bg-wa py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-mint-dark"
                  >
                    <MessageCircle className="h-4 w-4" />
                    Get Quote on WhatsApp
                  </a>
                  <a
                    href={PHONE_TEL}
                    data-testid={`category-call-${cat.id}`}
                    className="flex items-center justify-center gap-2 rounded-full border border-line bg-white py-3.5 text-sm font-semibold text-ink transition-colors duration-200 hover:border-brand hover:text-brand"
                  >
                    <Phone className="h-4 w-4" />
                    Call Now
                  </a>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
